export const ROUTES = {
  login: '/login',
  resetPassword: (token = ':token') => `/reset_password/${token}`,

  home: '/',

  bankSummaryTotal: '/banks-summary',
  bankSummary: (uuid = ':uuid') => `/banks-summary/${uuid}`,

  autoCredit: '/auto-credit',
  autoCreditCreate: '/auto-credit/create',
  autoCreditRequest: (uuid = ':uuid') => `/auto-credit/${uuid}`,

  serviceDesk: '/service-desk',
  serviceDeskCreate: '/service-desk/create',
  serviceDeskRequest: (uuid = ':uuid') => `/service-desk/${uuid}`,

  security: '/security',
  securityRequest: (uuid = ':uuid') => `/security/${uuid}`,

  insurances: '/insurances',
  insurancesCreate: '/insurances/create',
  insurancesRequest: (uuid = ':uuid') => `/insurances/${uuid}`,

  personal: '/personal',
  reports: '/reports',

  leasings: '/leasing',
  leasingIeRequest: (uuid = ':uuid') => `/leasing/ie/${uuid}`,
  leasingLlpRequest: (uuid = ':uuid') => `/leasing/llp/${uuid}`,

  posCredit: '/pos-credit',
  posCreditCreate: (id = ':id') => `/pos-credit/create/${id}`,
  posCreditRequest: (id = ':id') => `/pos-credit/${id}`,

  clients: '/clients',
  client: (uuid = ':uuid') => `/clients/${uuid}`,

  approvements: '/approvements',
  leads: '/leads',
  leadsUpdate: (uuid = ':uuid') => `/leads/${uuid}`,

  shareManagement: '/share-management'
};

export const CLIENT_ROUTES = {
  root: '/client',

  autoCredit: '/online',
  autoCreditCreate: '/online/create',
  autoCreditRequest: (uuid = ':uuid') => `/online/${uuid}`
};

export const FAQ_ROUTES = {
  root: '/faq',

  faqArticle: (uuid = ':uuid') => `/${uuid}`
};

export const getFullClientRoute = (route: string) =>
  `${CLIENT_ROUTES.root}${route}`;

export const ADMIN_ROUTES = {
  root: '/adminPage',
  home: '/',

  banks: '/banks',
  bank: (uuid = ':uuid') => `/banks/${uuid}`,

  executor: '/executor',
  logs: '/logs',
  reports: '/reports',

  faq: '/faq',
  faqCreate: '/faq/create',
  faqArticle: (id = ':id') => `/faq/${id}`,

  faqPageTypeCreate: '/faq-page-types/create',
  faqPageType: (id = ':id') => `/faq-page-types/${id}`,

  auto: '/auto',
  brand: (uuid = ':uuid') => `/auto/brands/${uuid}`,
  model: (uuid = ':uuid') => `/auto/models/${uuid}`,
  equipmentsCreate: '/auto/equipments/create',
  equipment: (id = ':id') => `/auto/equipments/${id}`,
  stocksCreate: '/auto/stocks/create',
  stock: (id = ':id') => `/auto/stocks/${id}`,
  usedCarsCreate: '/auto/used-cars/create',
  usedCar: (id = ':id') => `/auto/used-cars/${id}`,
  packagesCreate: '/auto/packages/create',
  package: (id = ':id') => `/auto/packages/${id}`,
  productsPackagesCreate: (packageId = ':packageId') =>
    `/auto/packages/${packageId}/create`,
  productPackage: (packageId = ':packageId', id = ':id') =>
    `/auto/packages/${packageId}/products/${id}`,

  products: '/products',
  product: (uuid = ':uuid') => `/products/${uuid}`,

  clients: '/clients',
  client: (uuid = ':uuid') => `/clients/${uuid}`,

  users: '/users',
  usersCreate: '/users/create',
  user: (id = ':id') => `/users/${id}/update`,
  positionCreate: '/users/position/create',
  position: (id = ':id') => `/users/position/${id}/update`,
  rolesActionCreate: '/users/roles_action/create',
  rolesAction: (id = ':id') => `/users/roles_action/${id}/update`,

  dealers: '/dealers',
  dealersCreate: '/dealers/create',
  dealer: (id = ':id') => `/dealers/${id}`,

  modules: '/modules',
  modulesCreate: '/modules/create',
  module: (uuid = ':uuid') => `/modules/${uuid}`,

  leasings: '/leasing',
  legalEntityLeasingCompany: (uuid = ':uuid') =>
    `/legal-entity-leasing-companies/${uuid}`,
  individualLeasingCompany: (uuid = ':uuid') =>
    `/individual-leasing-companies/${uuid}`,

  directory: '/directory',
  city: (uuid = ':uuid') => `/directory/cities/${uuid}`,
  brandsDirectoryCreate: '/directory/brands/create',
  brandDirectory: (uuid = ':uuid') => `/directory/brands/${uuid}`,
  categoriesCreate: '/directory/categories/create',
  category: (id = ':id') => `/directory/categories/${id}`,
  reasonsCreate: '/directory/reasons/create',
  reason: (id = ':id') => `/directory/reasons/${id}`,
  templatesCreate: '/directory/templates/create',
  template: (id = ':id') => `/directory/templates/${id}`,

  systemNotifications: '/system-notifications',
  systemNotification: (code = ':code') => `/system-notifications/${code}`,

  externalServices: '/external-services',
  externalService: (uuid = ':uuid') => `/external-services/${uuid}`,

  files: '/files',
  file: (uuid = ':uuid') => `/files/${uuid}`
};

export const getFullAdminRoute = (route: string) =>
  `${ADMIN_ROUTES.root}${route}`;
